import DOMPurify from 'dompurify';

export const linkifyHtml = (html: string): string => {
  if (!html) return '';
  
  // Clean first
  let cleanHtml = DOMPurify.sanitize(html, { ADD_ATTR: ['class', 'target', 'rel'] });

  const keywords = [
    { text: 'Brand Audit', url: '/brand-audit/' },
    { text: 'Brand Name Generator', url: '/' },
    { text: 'Shoe Brand Name Generator', url: '/shoe-brand-name-generator/' },
    { text: 'Coffee Brand Name Generator', url: '/coffee-brand-name-generator/' },
    { text: 'AI Prompt Generator', url: '/ai-prompt-generator/' }
  ];

  if (typeof window !== 'undefined' && window.DOMParser) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cleanHtml, 'text/html');
      
      const walk = (node: Node) => {
        let child, next;
        switch (node.nodeType) {
          case 1: // Element
          case 9: // Document
          case 11: // Document fragment
            if ((node as Element).tagName?.toLowerCase() === 'a') {
               return; // Do not linkify inside <a> tags
            }
            child = node.firstChild;
            while (child) {
              next = child.nextSibling;
              walk(child);
              child = next;
            }
            break;
          case 3: // Text node
            handleText(node);
            break;
        }
      };
      
      const handleText = (textNode: Node) => {
        let textVal = textNode.nodeValue || '';
        let replaced = false;
        
        // Find if any keyword is in this text node
        keywords.forEach(kw => {
          if (textVal.includes(kw.text)) {
            replaced = true;
          }
        });
        
        if (replaced) {
          let newHtml = textVal;
          // Sort keywords by length descending so longer phrases match first
          const sortedKeywords = [...keywords].sort((a, b) => b.text.length - a.text.length);
          
          sortedKeywords.forEach(kw => {
            // Only replace if it is a standalone phrase, case-sensitive
            // Avoid matching if it's already inside a link (which shouldn't happen because we skip A tags)
            const regex = new RegExp(`\\b(${kw.text})\\b`, 'g');
            newHtml = newHtml.replace(regex, `<a href="${kw.url}" class="text-[#4F46E5] hover:text-[#6366F1] underline font-medium">$1</a>`);
          });
          
          if (newHtml !== textVal) {
             const span = document.createElement('span');
             span.innerHTML = newHtml;
             if (textNode.parentNode) {
               textNode.parentNode.replaceChild(span, textNode);
             }
          }
        }
      };
      
      walk(doc.body);
      cleanHtml = doc.body.innerHTML;
    } catch (e) {
      console.error("Linkify error", e);
    }
  }

  return cleanHtml;
};
